import { useState, useEffect } from 'react'
import { get } from '../api'

export const useFetchData = ({ path, queryString}) => {
  const [data, setData] = useState(null)

  const fetchData = async () => {
    try {
      const { data } = await get({ path, queryString })
      setData(data)
    } catch (error) {
      console.log('useFetchData error', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return [data, fetchData, setData]
}